import { gql } from '@apollo/client';

export const GET_STORES = gql(/* GraphQL */ `
    query GetStores {
        getStores {
            id
            name
            storeNo
            advertisingZoneId
            isSalesModuleEnabled
            isPriceChangeModuleEnabled
            isPriceSurveyModuleEnabled
            isClosed
            isPhysicalStore
            managers {
                id
                firstName
                lastName
            }
        }
    }
`);

export const GET_ACCESSIBLE_SURVEY_STORES = gql`
    query GetAccessibleSurveyStores {
        getAccessibleSurveyStores {
            id
            name
            storeNo
            isPriceSurveyModuleEnabled
        }
    }
`;

export const GET_STORE = gql(/* GraphQL */ `
    query GetStore($id: String!) {
        getStore(id: $id) {
            id
            name
            isSalesModuleEnabled
            isPriceChangeModuleEnabled
            isClosed
            isPhysicalStore
            managers {
                id
                firstName
                lastName
            }
        }
    }
`);

export default GET_STORES;
